// Флаг страны (country_ref.image сервера) в кружке 16; нет картинки — ничего не рисуем (не выдумываем).
import { useState } from 'react';
import styles from './Flag.module.css';

export function Flag({ src, size = 16, className }: { src: string | null | undefined; size?: number; className?: string }) {
  const [failed, setFailed] = useState(false);
  if (!src || failed) return null;
  return <img className={`${styles.flag} ${className ?? ''}`} src={src} alt="" width={size} height={size} loading="lazy" decoding="async"
    onError={() => setFailed(true)} />;
}
